import React, { ReactElement } from 'react';
import { styled, SimpleMenuList, SimpleMenuItem } from '@erecruit/ui-kit';
import { useFilterByPermissions } from '@erecruit/modules';
import { Intl } from '@erecruit/core';
import { AppPermissions } from '@erecruit/types';

import { History, Location } from 'history';
import { EditModeElementWrapper } from './EditModeContextProvider';

const { FormattedMessage } = Intl;

const menuItems: (SimpleMenuItem & { permission?: string })[] = [
  {
    icon: 'dashboard',
    key: '/dashboard',
    text: <FormattedMessage id={messageIds.vms.menu.dashboard} />,
  },
  {
    icon: 'positions',
    key: '/positions',
    text: <FormattedMessage id={messageIds.vms.menu.positions} />,
    permission: AppPermissions.ViewPositions,
  },
  {
    icon: 'calendar',
    key: '/shifts',
    text: <FormattedMessage id={messageIds.vms.menu.shifts} />,
    permission: AppPermissions.ViewShifts,
  },
  {
    icon: 'match',
    key: '/matches',
    text: <FormattedMessage id={messageIds.vms.menu.matches} />,
    permission: AppPermissions.ViewMatches,
  },
  {
    icon: 'time',
    key: '/timesheets',
    text: <FormattedMessage id={messageIds.vms.menu.timesheets} />,
    permission: AppPermissions.Timesheets,
  },
  {
    icon: 'settings',
    key: '/settings',
    text: <FormattedMessage id={messageIds.vms.menu.settings} />,
    position: 'sticky',
    stickyIndex: 0,
  },
  {
    icon: 'reports',
    key: '/reports',
    text: <FormattedMessage id={messageIds.vms.menu.reports} />,
    permission: AppPermissions.Reports,
  },
];

const MenuContainer = styled.div<{}>(({ theme }) => ({
  background: theme.newColors.bgNavigation,
  color: theme.newColors.bodyTertiary,
  fontSize: 12,
  fontWeight: 600,
  height: '100%',
  padding: 0,
  textAlign: 'center',
  width: 96,
}));

interface MenuProps {
  history: History;
  location: Location;
}

const Menu = ({ history, location }: MenuProps): ReactElement => {
  const authorizedMenuItems = useFilterByPermissions(menuItems);

  return (
    <MenuContainer>
      <EditModeElementWrapper>
        <SimpleMenuList
          items={authorizedMenuItems}
          selectedKeys={[`/${location.pathname.split('/')[1]}`]}
          history={history}
        />
      </EditModeElementWrapper>
    </MenuContainer>
  );
};

export default Menu;
